type ScoreBadgeProps = {
  score: number;
  size?: "sm" | "md";
  /** Motivos del score (se muestran al pasar el cursor). */
  notes?: string[];
};

function tone(score: number) {
  if (score >= 80) return "bg-primary-500/15 text-primary-700";
  if (score >= 65) return "bg-accent-500/15 text-accent-700";
  if (score >= 50) return "bg-secondary-500/15 text-secondary-700";
  return "bg-background-200 text-foreground-600";
}

export default function ScoreBadge({ score, size = "sm", notes }: ScoreBadgeProps) {
  const dim = size === "md" ? "w-10 h-10 text-sm" : "w-9 h-9 text-xs";
  return (
    <div
      className={`${dim} rounded-full flex flex-col items-center justify-center font-heading font-extrabold leading-none ${tone(score)}`}
      title={notes && notes.length > 0 ? `Score IA: ${score}/100\n- ${notes.join("\n- ")}` : `Score IA: ${score}/100`}
    >
      <span>{score}</span>
      <span className="text-[8px] font-semibold opacity-70">IA</span>
    </div>
  );
}